<template>
  <section class="speaker-list  gold-color-wrapper ">
  <div class="container-row">
    <div class="speaker-role">
      <div class="speaker-list-wrapper align-left">
          
       
                <div class="speaker-list-col no-desc"
                 
                    v-for="speaker in filteredSpeakers"
                    v-bind:key="speaker.id"
                  >
                  <div class="speaker-col-wapper ">
                    
                    <router-link
                      :to="{
                        name: 'SpeakerDetails',
                        query: { userId: speaker.apiId },
                        hash: '#top',
                      }"
                      v-slot="{ href, navigate }"
                    >
                    
                      <a
                        :href="href" @click="navigate" target="_blank"
                        class="speaker"
                      >
                       
                          <div class="speaker-col-wrapper_image">
                            <picture>
                            <img
                              v-if="
                                speaker.avatar == null || speaker.avatar == ''
                              "
                              src="https://www.egyptminingforum.com/media/jnoeomny/speakerdefault.png"
                              alt=""
                            />
                            <img
                            v-else-if="
                              speaker.avatar == 'https://www.dmgeventsconferences.com/'
                            "
                            src="https://www.egyptminingforum.com/media/jnoeomny/speakerdefault.png"
                            alt=""
                          />
                            <img
                              v-else
                              :srcset="
                                speaker.avatar +
                                  '?width=224&height=224&mode=crop'
                              "
                            />
                          </picture>
                          <svg class="plus-sign" x="0px" y="0px" viewBox="0 0 292.377 292.377" style="enable-background:new 0 0 292.377 292.377;" xml:space="preserve"><path style="fill:#fff;" d="M146.188,0C65.576,0,0,65.582,0,146.188s65.576,146.188,146.188,146.188s146.188-65.582,146.188-146.188S226.801,0,146.188,0z M194.962,152.155h-42.806v42.8c0,3.3-2.667,5.967-5.967,5.967c-3.3,0-5.967-2.667-5.967-5.967v-42.8H97.415c-3.294,0-5.967-2.673-5.967-5.967s2.673-5.967,5.967-5.967h42.806V97.415c0-3.294,2.667-5.967,5.967-5.967c3.3,0,5.967,2.673,5.967,5.967v42.806h42.806c3.3,0,5.967,2.673,5.967,5.967S198.261,152.155,194.962,152.155z"></path></svg>
                          </div>
                          <div class="speaker-col-wrapper_content">
                         
                            <span class="speaker-name">{{ speaker.name }}</span>
                              <p><b>{{ speaker.jobTitle }}</b></p>
                              <p class="company-name">
                                {{ speaker.company }}
                              </p>
                            
                          
                          </div>
                        
                      </a>
                    </router-link>
                 
                  </div>
                </div>
              </div>
            </div>
    
  </div>
</section>
</template>

<script>
import axios from "axios";
import url from "./../../config/url";
export default {
  name: "ExhibitorList",
  data() {
    return {
      speakerList: [],
      searchQuery: "",
    };
  },
  computed: {
    filteredSpeakers() {
      console.log(this.speakerList)
  return this.speakerList
    .filter((speaker) => 
      speaker.name.toLowerCase().includes(this.searchQuery.toLowerCase())
    )
    .sort((a, b) => a.company.localeCompare(b.company));
}
  },
  mounted() {
    //debugger
    const url = window.location.href;
    const domain = url.split("/")[2];
    console.log(domain);
    if (domain === "www.futureenergyasia.com") {
      this.eventname = "fma";
    } else if (domain === "www.future-mobility.asia") {
      this.eventname = "fma";
    } else if (domain === "www.japanenergyevent.com") {
      this.eventname = "japan";
    } else if (domain === "www.gastechevent.com") {
      this.eventname = "gastech";
    } else if (domain === "www.egyptminingforum.com") {
      this.eventname = "emf";
    } else {
      this.eventname = "emf";
    }
    const pathname = window.location.pathname;
    if (pathname.includes("strategic")) {
      this.type = "Strategic";
    } else if (pathname.includes("technical")) {
      this.type = "Technical";
    } else if (pathname.includes("2024-speakers")) {
      this.type = "Technical";
    } else {
      this.type = "";
    }
    this.getAllSpeakerList(this.eventname, this.type);
  },
  methods: {
    getAllSpeakerList(eventname, type) {
      axios
        .get(url.category_list_api(eventname, type))
        .then((response) => {
          // Sort the speaker list by name in alphabetical order
          if (type === "Technical") {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
          }
          this.speakerList = response.data;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
  },
};
</script>
<style>
#options .option-combo ul {
  margin: 0;
  display: inline-block;
  width: calc(100% - 200px);
}

img.filter-block-logo {
  max-width: 150px;
  width: 100%;
}

.subject-outer p {
  font-size: 15px;
}

.wrap-programme {
  padding: 40px 0 0;
}

.date-filter-block {
  display: flex;
  align-items: center;
}

.sub-sp-block {
  width: 80%;
}

@media (max-width: 1199px) {
  .date-filter-block {
    display: block;
  }

  img.filter-block-logo {
    display: block;
    margin: 0 auto 20px !important;
    max-width: 200px;
  }

  #options .option-combo ul {
    width: 100%;
  }

  .active {
    display: block;
  }
}
</style>
